"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfConversationListItemDto = instanceOfConversationListItemDto;
exports.ConversationListItemDtoFromJSON = ConversationListItemDtoFromJSON;
exports.ConversationListItemDtoFromJSONTyped = ConversationListItemDtoFromJSONTyped;
exports.ConversationListItemDtoToJSON = ConversationListItemDtoToJSON;
exports.ConversationListItemDtoToJSONTyped = ConversationListItemDtoToJSONTyped;
/**
 * Check if a given object implements the ConversationListItemDto interface.
 */
function instanceOfConversationListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function ConversationListItemDtoFromJSON(json) {
    return ConversationListItemDtoFromJSONTyped(json, false);
}
function ConversationListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function ConversationListItemDtoToJSON(json) {
    return ConversationListItemDtoToJSONTyped(json, false);
}
function ConversationListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}
//# sourceMappingURL=ConversationListItemDto.js.map